/**
 * SD-10930: the connection a bank account prefers to import its transactions from. Mirrors the
 * backend constants in `App\Modules\Treasury\App\Constants\TransactionImportSources` — keep the
 * string values in sync.
 *
 * Null on the model means no preference was recorded, and every connection the account holds
 * still imports. The Treasury account is always null.
 */
export enum TransactionImportSource {
    PLAID = 'plaid',
    FINANCIAL_CONNECTIONS = 'financial_connections',
}
